import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import gql from 'graphql-tag';
import { ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { cliente_proveedor } from 'src/app/shared/object/cliente_proveedor.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';

@Component({
  selector: 'app-clientes-form-datos-comerciales',
  templateUrl: './form-datos-comerciales.component.html',
  styleUrls: ['../clientes.component.scss'],
  providers: [SecurityService, ValidadoresService],
})
export class FormDatosComercialesComponent implements OnInit {
  optionsMixtura: Array<any> = [];

  private client: GraphQLClient = null;

  // Forms
  public formDatosComercialesyFacturadorE: FormGroup;

  // Data & Tmp
  public rutEmpresa: number;
  public sucursalEmpresa: number;
  public codigoModulo: number;
  public rutUsuario: number;

  // Utils
  private log: any;

  constructor(
    client: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    public validadores: ValidadoresService,
    public toastService: ToastService,
    private messageRendererService: MessageRendererService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService
  ) {
    this.log = this.clog.log('MANTENEDOR-CLIENTES/ FORM DATOS COMERCIALES');
    this.client = client;
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
    this.codigoModulo = 1;
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());

    this.formDatosComercialesyFacturadorE = this.createForm();


  }

  createForm() {
    // const emailPattern = '[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$'
    const emailPattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
    return this.fb.group({
      nombreFantasia: ['', []],
      giroComercial: ['', [Validators.required]],
      emailIntercambio: ['', [Validators.maxLength(50), Validators.email]], // , Validators.pattern(emailPattern)
      emailEnvioPdf: ['', [Validators.maxLength(50), Validators.email]], // , Validators.pattern(emailPattern)
    });
  }

  /**
   * Carga datos para visualización. El permiso de edición se valida al guardar (modal).
   */
  loadAndShow(cliente: cliente_proveedor, onDatosCargados?: () => void) {
    this.log('showModalModificarDtoComerciales', cliente);
    const self = this;
    this.showModalModificarDtoComercialesParte2(cliente.rut, onDatosCargados);
  }

  showModalModificarDtoComercialesParte2(rutCliente: any, onDatosCargados?: () => void) {
    const self = this;
    self.log('rutCliente', rutCliente);
    this.client.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $rutCliente: Decimal) {
            cliente_proveedor {
              obtenerSegunId(entidad: { rut: $rutCliente, empresa_rut: $rutEmpresa }) {
                respuesta {
                  nombre
                  mail_intercambio
                  mail_pdf
                  giro
                }
              }
            }
          }
        `,
        variables: {
          rutEmpresa: Number(self.rutEmpresa),
          rutCliente: rutCliente,
        },
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        const resp = respuesta.data.cliente_proveedor.obtenerSegunId.respuesta;
        if (!resp) {
          return;
        }
        const { nombre, mail_intercambio, mail_pdf, giro } = resp;

        self.formDatosComercialesyFacturadorE.reset();
        self.formDatosComercialesyFacturadorE.get('nombreFantasia').setValue(nombre);
        self.formDatosComercialesyFacturadorE.get('giroComercial').setValue(giro);
        self.formDatosComercialesyFacturadorE.get('emailIntercambio').setValue(mail_intercambio);
        self.formDatosComercialesyFacturadorE.get('emailEnvioPdf').setValue(mail_pdf);
        if (onDatosCargados) {
          onDatosCargados();
        }
      }
    );
  }

  /** Solo lectura: sin permiso de edición el usuario ve datos pero no modifica. */
  setModoSoloLectura(soloLectura: boolean) {
    if (soloLectura) {
      this.formDatosComercialesyFacturadorE.disable();
    } else {
      this.formDatosComercialesyFacturadorE.enable();
    }
  }

  validate() {
    this.formValidatorsService.validateAllFormFields(this.formDatosComercialesyFacturadorE);
    return this.formDatosComercialesyFacturadorE.valid;
  }

  getFormData() {
    return this.formDatosComercialesyFacturadorE.getRawValue();
  }

  reset() {
    this.formValidatorsService.reset(this.formDatosComercialesyFacturadorE);
  }

  setNombreFantasia(nombre: string) {
    this.formDatosComercialesyFacturadorE.get('nombreFantasia').setValue(nombre);
  }

  SetGiroComercial(giro: string) {
    this.formDatosComercialesyFacturadorE.get('giroComercial').setValue(giro);
  }
}
